class NavigationBar {
    constructor(navigationBar) {
        this.navigationBar            = navigationBar
        this.body                     = document.querySelector('body')
        this.html                     = document.documentElement
        this.navBarMobileWrapper      = this.navigationBar.querySelector('.k-nav-items-wrapper')
        this.btnOpenNavMobile         = this.navigationBar.querySelector('.btn-open-nav')
        this.btnCloseNavMobile        = this.navigationBar.querySelector('.btn-close-nav')
        this.btnOpenNavMobileLoggedIn = this.navigationBar.querySelector('.btn-logged-in-mobile')
        this.accordionsContent        = this.navigationBar.querySelectorAll('.k-accordion-content')
        this.btnsToggleContent        = this.navigationBar.querySelectorAll('.k-nav-toggle-content')
        this.showNavbar               = false
        this.showNavbarLoggedInMobile = false
        this._loadEvents()
        this._removeDisplayNoneFromAccordions()
        this.checkTransitionOfContent()
        this.addDynamicElements()
    }

    _loadEvents() {
        this.toggleNavBarMobileEvents()
        this.toggleNavBarDesktopContentEvents()
        this.checkWindowsSizeEvents()
        this.body.style.position = 'relative'
    }

    _removeDisplayNoneFromAccordions() {
        if (this.accordionsContent) {
            this.accordionsContent.forEach(accordionContent => {
                accordionContent.style.display = 'block'
            })
        }
    }

    toggleNavBarMobileEvents() {
        let btnsToggleNav = this.navigationBar.querySelectorAll('.btn-toggle-nav')
        btnsToggleNav.forEach(btnTrigger => {
            btnTrigger.addEventListener('click', () => {
                let toggleMobileLoggedIn = btnTrigger.getAttribute('toggle-mobile-logged-in')
                this.toggleNavBarMobile(false, toggleMobileLoggedIn)
            })
        });
    }

    toggleNavBarDesktopContentEvents() { // Only for desktop
        if (this.btnsToggleContent) {
            this.btnsToggleContent.forEach(btnTrigger => {
                btnTrigger.addEventListener('mouseover', () => {
                    this.toggleContent(btnTrigger)
                })
                btnTrigger.addEventListener('mouseout', () => {
                    this.toggleContent(btnTrigger, 'hidden')
                })
            })
        }
    }

    toggleContent(btnTrigger, toggleOption = 'show') { // Only for desktop
        let dataToggle = btnTrigger.getAttribute('data-toggle')
        if (!dataToggle) {
            alert('data-toggle is required')
            return	
        }
        let accordionContent = this.navigationBar.querySelector(`[data-toggle-content="${dataToggle}"]`)

        if (screen.width >= 1025) {
            if (accordionContent) {
                if (toggleOption === 'show') {
                    accordionContent.classList.add('k-nav-accordion-content-show')
                    btnTrigger.classList.add('k-nav-accordion-content-btn-show')
                    btnTrigger.classList.add('nav-hoverable-menu-item')
                } else {
                    accordionContent.classList.remove('k-nav-accordion-content-show')
                    btnTrigger.classList.remove('k-nav-accordion-content-btn-show')
                    btnTrigger.classList.remove('nav-hoverable-menu-item')
                }
            }
        } else {
            if (accordionContent) {
                accordionContent.classList.remove('k-nav-accordion-content-show')
                btnTrigger.classList.remove('k-nav-accordion-content-btn-show')
            }
        }
    }   

    removeToggleClassesForDesktop() {
        this.btnsToggleContent.forEach(btnTrigger => {
            let dataToggle = btnTrigger.getAttribute('data-toggle')

            if(this.navigationBar.querySelector(`[data-toggle-content="${dataToggle}"]`) != null){
                let accordionContent = this.navigationBar.querySelector(`[data-toggle-content="${dataToggle}"]`)
                let btnAccordion     = btnTrigger.querySelector(`button.k-accordion-button`)
                accordionContent.classList.remove('k-accordion-show')
                btnAccordion.classList.remove('k-accordion-open')
                accordionContent.style = ''
                this.toggleContent(btnTrigger, 'hidden')
            }
        })
    }

    checkTransitionOfContent() {
        if (window.screen.width >= 1025) {
            this.toggleNavBarMobile(true)
            this.body.style.overflow = 'initial'
            this.html.style.overflow = 'initial'
            this.accordionsContent.forEach(accordionContent => {
                accordionContent.classList.add('transition-03')
                this.navBarMobileWrapper.classList.remove('transition-03-left')
            })
        } else {
            this.accordionsContent.forEach(accordionContent => {
                accordionContent.classList.remove('transition-03')
                setTimeout(() => {
                    this.navBarMobileWrapper.classList.add('transition-03-left')
                }, 400);
            }) 
        }
    }

    checkWindowsSizeEvents() {
        window.onresize = () => {
            this.removeToggleClassesForDesktop(true)
            this.checkTransitionOfContent()
        }
    }

    toggleNavBarMobile(forceHidden = false, toggleMobileLoggedIn = false) {
        this.showNavbar = !this.showNavbar
        if (forceHidden) {
            this.showNavbar = false
        }
        if (toggleMobileLoggedIn) {
            this.showNavbar = true
            this.toggleMobileLoggedInContent()
        } else {
            this.toggleMobileLoggedInContent(true)
        }

        if(this.showNavbar) {
            this.navBarMobileWrapper.classList.add('k-nav-items-wrapper-show')
            this.btnOpenNavMobile.classList.add('btn-toggle-nav-hidden')
            this.btnCloseNavMobile.classList.remove('btn-toggle-nav-hidden')
            this.body.style.overflow = 'hidden'
            this.html.style.overflow = 'hidden'
        } else {
            this.navBarMobileWrapper.classList.remove('k-nav-items-wrapper-show')
            this.btnOpenNavMobile.classList.remove('btn-toggle-nav-hidden')
            this.btnCloseNavMobile.classList.add('btn-toggle-nav-hidden')
            this.body.style.overflow = 'initial'
            this.html.style.overflow = 'initial'
        }
    }

    toggleMobileLoggedInContent(hiddenLoggedIn = false) {
        this.btnsToggleContent.forEach(btnTrigger => {
            let dataToggle = btnTrigger.getAttribute('data-toggle')
            if (dataToggle === 'content-logged-in') {
                if (hiddenLoggedIn) {
                    btnTrigger.classList.remove('k-toggle-content-logged-in')
                } else {
                    btnTrigger.classList.add('k-toggle-content-logged-in')
                }
            } else {
                if (hiddenLoggedIn) {
                    setTimeout(() => {
                        btnTrigger.style.display = 'block'
                    }, 400);
                } else {
                    btnTrigger.style.display = 'none'
                }
            }
        })
    }

    addDynamicElements() {

    }
}


const init = () => {
    const navigationBar = document.querySelector('.k-navigation-bar')
    if (navigationBar) {
        let NavigationBarInstance = new NavigationBar(navigationBar);
    } else {
        alert('.k-navigation-bar not found')
    }
}


export {
    init
};